const th = {
  kicker: "สำหรับธุรกิจท้องถิ่นและเจ้าของบ้าน",
  title: "มาเป็นเจ้าบ้านใน Trollfossjakten",
  lead: "เจ้าบ้านคือธุรกิจท้องถิ่นหรือเจ้าของบ้านตามเส้นทางระหว่าง Lavangen และ Årstein (Gratangen) — คาเฟ่ ฟาร์ม กระท่อม B&B ซาวน่า หรือร้านค้า เจ้าบ้านต้อนรับแขกที่มาเล่นเกมล่าโทรลล์ และรับ Troll Kroner (TK) ซึ่งเป็นเงินของเกมเป็นค่าชำระ",
  badges: ["ฟรี", "ประมาณ 2 นาที", "ขึ้นแผนที่ทันที"],
  waysKicker: "สองวิธีในการเข้าร่วม",
  waysTitle: "เลือกหนึ่งอย่าง — หรือทั้งสองอย่าง",
  ways: [
    { title: "จุดเจ้าบ้าน", tag: "รับ Troll Kroner", body: "คุณจะปรากฏบนแผนที่ และแขกสามารถจ่ายเงินให้คุณด้วย TK ในกระเป๋าเงินของพวกเขา" },
    { title: "จุดแวะพัก", tag: "แสดงข้อมูลเท่านั้น", body: "หมุดบนแผนที่ที่แสดงบริการของคุณ เช่น ชาร์จรถยนต์หรือจักรยาน ห้องอาบน้ำ เมนูอาหาร B&B แคมป์ปิ้ง wifi ที่จอดรถ ห้องน้ำ และกาแฟ เป็นการโปรโมตฟรี — ไม่มีการรับเงิน" },
  ],
  both: "ทำทั้งสองอย่างได้",
  joinKicker: "วิธีเป็นเจ้าบ้าน",
  joinTitle: "ประมาณ 2 นาที และฟรี",
  steps: ["ดาวน์โหลดแอปและลงชื่อเข้าใช้", "ไปที่ โปรไฟล์ → เป็นเจ้าบ้าน → ลงทะเบียนเป็นเจ้าบ้าน", "กรอกข้อมูลของคุณ (ดูรายการ)", "เสร็จแล้ว — คุณขึ้นแผนที่ทันที"],
  formTitle: "สิ่งที่ต้องกรอก",
  fields: [["ชื่อธุรกิจ", "จำเป็น"], ["ที่อยู่", "จำเป็น"], ["โทรศัพท์", "ไม่บังคับ"], ["สิ่งที่คุณมีให้", "เช่น “กาแฟ วาฟเฟิล ซาวน่า”"]],
  amenitiesTitle: "สิ่งอำนวยความสะดวกของคุณ",
  noWait: "ไม่ต้องรออนุมัติ และไม่มีค่าสมัคร",
  pitTitle: "เพิ่มจุดแวะพัก",
  pitBody: "ไปที่ โปรไฟล์ → เปิดจุดแวะพัก → ลงทะเบียนจุดแวะพัก แล้วกรอกชื่อ ที่อยู่ โทรศัพท์ ตำแหน่งบนแผนที่ และสิ่งอำนวยความสะดวก",
  tkKicker: "Troll Kroner ทำงานอย่างไร",
  tkTitle: "1 TK = 1 NOK",
  tkEarnTitle: "แขกได้รับ TK จาก",
  tkEarn: ["การชวนเพื่อน — ได้คืน 50% จากการซื้อพาสครั้งแรกของเพื่อน", "โบนัสระดับ Arrow Hunter: +10 / +25 / +100 TK", "การหมุนวงล้อรางวัล"],
  tkRule: "TK ใช้ได้เฉพาะกับเจ้าบ้านที่ลงทะเบียนแล้ว แขกไม่สามารถแลกเป็นเงินสดได้",
  payKicker: "การรับชำระเงิน",
  payTitle: "แดชบอร์ดเจ้าบ้านคำนวณให้คุณ",
  paySteps: ["แขกเปิด โปรไฟล์ → แสดง QR ชำระเงินของฉัน", "คุณสแกน หรือพิมพ์รหัสกระเป๋าเงิน (TK-XXXXXX)", "ใส่จำนวนเงินเป็น NOK และสิ่งที่ซื้อ เช่น “กาแฟและวาฟเฟิล”", "แอปจะหัก TK ให้มากที่สุดเท่าที่ทำได้ และแสดงยอดที่เหลือให้เก็บเป็นเงินสดหรือบัตร"],
  exampleTitle: "ตัวอย่าง",
  example: { note: "ซื้อ 85 kr มี 60 TK ในกระเป๋า", total: "ยอดซื้อ", tk: "จ่ายด้วย TK", rest: "เก็บเป็นเงินสดหรือบัตร" },
  dashboard: "แดชบอร์ดแสดงทุกการขาย รวมถึง TK ที่ได้รับวันนี้และทั้งหมด",
  ctaTitle: "พร้อมต้อนรับแขกโทรลล์หรือยัง?",
  ctaBody: "ดาวน์โหลดแอป ลงชื่อเข้าใช้ และลงทะเบียนเป็นเจ้าบ้าน — ใช้เวลาประมาณสองนาที",
  cta: "ดาวน์โหลดแอป",
  ctaPartner: "อยากมีโทรลล์ของตัวเองด้วยไหม? ดูแพ็กเกจพันธมิตร",
  ctaHost: "ลงทะเบียนเป็นเจ้าบ้าน",
  webNote: "อยากใช้เว็บไซต์มากกว่า? ลงทะเบียนที่นี่ — ปักหมุดสถานที่ของคุณบนแผนที่ บอกว่าคุณมีอะไรให้บริการ และติ๊กสิ่งอำนวยความสะดวก",
};

export default th;
